import React, {Component, Fragment} from 'react';
import connect from "react-redux/es/connect/connect";
import GameSubTab from "../components/gameSubTab";
import {MATCHDAY_MODULE_TYPE} from "../../sports-book/modules/matchday/constants/identifiers";
import style from '../css/gameSubTab.css';
import {isTextBasedGame} from '../modules/matchday/helpers/matchdayHelper';

const mapStateToProps = (state, ownProps) => {
    return {
        games: state.vpp.games,
        selectedGameIndex: state.vpp.selectedGameIndex,
        selectedEventIndex: state.vpp.selectedEventIndex,
        events: state.vpp.events,
        systemLanguage: state.vpp.systemLanguage
    };
};

class GameSubTabsContainer extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            games: storeData.vpp.games,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            selectedEventIndex: storeData.vpp.selectedEventIndex,
            events: storeData.vpp.events,
            matchdayUpdated: storeData.vpp.matchdayUpdated,
            selectedGameIndex: storeData.vpp.selectedGameIndex,
            systemLanguage: storeData.vpp.systemLanguage
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                ...this.state,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                nextEventsTimeStamp: storeData.vpp.nextEventsTimeStamp,
                serverTimeOffset: storeData.vpp.serverTimeOffset,
                games: storeData.vpp.games,
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
                matchdayUpdated: storeData.vpp.matchdayUpdated,
                selectedGameIndex: storeData.vpp.selectedGameIndex,
                systemLanguage: storeData.vpp.systemLanguage
            });
        }
    }

    _getSelectedCategories() {
        let categoryOrder = this.state.games[this.state.selectedGameIndex].categoryOrder;
        return this.props.gameCategories.find(gameCategory => gameCategory.order === categoryOrder);
    }

    render() {
        let content, loading;
        let store = this.props.store;
        let storeData = store.getState();

        if ((this.state.events.length > 0 && storeData.vpp.games.length > 0 && this.state.events[0] !== undefined && this.state.events[0].channel !== storeData.vpp.games[this.state.selectedGameIndex].channel)
            || (process.env.NODE_ENV !== 'development'
                ? (storeData.vpp.games[this.state.selectedGameIndex].type === MATCHDAY_MODULE_TYPE
                    ? this.state.matchdayUpdated === false
                    : false)
                : false)) {
            loading = (<div className={style.loading}><span>&bull;</span><span>&bull;</span><span>&bull;</span></div>);
        } else {
            if (this.state.games[this.state.selectedGameIndex].type === MATCHDAY_MODULE_TYPE
                && this.state.events != undefined
                && this.state.events[this.state.selectedEventIndex] != undefined
                && this.state.games[this.state.selectedGameIndex].channel === this.state.events[this.state.selectedEventIndex].channel 
                && !isTextBasedGame(this.state.games[this.state.selectedGameIndex].channel)) {

                let game = this.state.games[this.state.selectedGameIndex];
                let size = this.state.events[this.state.selectedEventIndex].length;

                content = this.state.events[this.state.selectedEventIndex].slice(0, size).map(
                    (event, index) => {
                        return (event !== undefined) ?
                            <GameSubTab game={game} index={index} store={this.props.store} matchdayEvent={event}
                                        key={index}/>
                            : null;
                    });
            } else {
                content = this._getSelectedCategories().games.map((game, index) => <GameSubTab game={game}
                                                                                               gameindex={index}
                                                                                               key={index}
                                                                                               store={this.props.store}/>);
            }
        }
        return <Fragment>
            {loading}
            {content}
        </Fragment>;
    }
}

export default connect(mapStateToProps)(GameSubTabsContainer);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/containers/gameSubTabsContainer.js